const initialState = {
  meta: {},
  loading: false,
  error: ''
}

const metaReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'META_REQUEST':
      return {
        ...state,
        loading: true
      }
    case 'META_SUCCESS':
      return {
        ...state,
        loading: false,
        meta: action.payload,
        error: ''
      }
    case 'META_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default metaReducer
